const GTM_ID = 'GTM-WP5D5HK';
const GTM_SCRIPT_ID = 'google-tag-manager';

type DataLayerValue = string | number | boolean | undefined;
type DataLayerEntry = Record<string, DataLayerValue>;

export type DataLayerEvent = {
  event: 'screen_view' | 'select_content' | 'exception';
  [key: string]: DataLayerValue;
};

declare global {
  interface Window {
    dataLayer: DataLayerEntry[];
  }
}

export function pushDataLayer(event: DataLayerEvent) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
}

export function initializeGtm() {
  if (document.getElementById(GTM_SCRIPT_ID)) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: 'gtm.js', 'gtm.start': Date.now() });

  const script = document.createElement('script');
  script.id = GTM_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  document.head.appendChild(script);
}

export function trackScreenView(screenName: string) {
  pushDataLayer({
    event: 'screen_view',
    screen_name: screenName,
    page_location: window.location.href,
    page_path: `${window.location.pathname}${window.location.search}`,
    page_title: document.title,
  });
}

export function trackSelectContent(contentType: string, contentId: string) {
  pushDataLayer({
    event: 'select_content',
    content_type: contentType,
    content_id: contentId,
  });
}

export function trackException(description: string, fatal = false) {
  pushDataLayer({
    event: 'exception',
    description,
    fatal,
  });
}